"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_WORDING_MISSING = void 0;
exports.wordingByNumber = wordingByNumber;
exports.reportWording = reportWording;
// Each measure's configured report wording, by measure number (CR-002 CR2-111; D-1114): its short
// label and its `report` block. A measure number can appear once per collection type; the wording
// lives on the entry that has a `report` block, so that entry wins over its siblings (D-1137).
const measures_js_1 = require("../config/measures.js");
const report_rules_js_1 = require("../config/report-rules.js");
function wordingByNumber(doc) {
    const byNumber = new Map();
    for (const m of doc.measures) {
        if (byNumber.has(m.number) && m.report === undefined)
            continue;
        byNumber.set(m.number, {
            shortLabel: m.short_label,
            rules: m.report?.rules ?? {},
            exclusionLabels: m.report?.exclusion_labels ?? {},
        });
    }
    return byNumber;
}
/** The 422 reason when the Quality report's wording is missing (J-203, the owner's inbox file 06). */
exports.REPORT_WORDING_MISSING = "REPORT_WORDING_MISSING";
/**
 * J-203: the report's wording for these measures, or every reason it is missing. A row is labelled
 * only by its measure's rule table and the measures document's text for it; without either, a row
 * would show the raw registry status, an empty action and no gap, so the caller fails loudly instead.
 * `measureNumbers` are `ref.measure.measure_number` values, which the measures document keeps at
 * three digits ("001"), the same form `REPORT_RULE_KEYS` is keyed by.
 */
function reportWording(year, document, measureNumbers) {
    if (document === undefined || document === null)
        return { success: false, problems: [`The measures document for ${year} is missing.`] };
    const parsed = (0, measures_js_1.parseMeasuresDocument)(String(year), document);
    if (!parsed.success) {
        const first = parsed.issues[0];
        const where = first === undefined ? "" : ` (${first.path}: ${first.message})`;
        return {
            success: false,
            problems: [`The measures document for ${year} is not valid${where}.`],
        };
    }
    const wordings = wordingByNumber(parsed.data);
    const problems = [...new Set(measureNumbers)].flatMap((number) => {
        const keys = report_rules_js_1.REPORT_RULE_KEYS[number];
        if (keys === undefined)
            return [`Measure ${number} has no report rule table.`];
        const rules = wordings.get(number)?.rules ?? {};
        return keys.every((key) => Object.hasOwn(rules, key))
            ? []
            : [`Measure ${number} has no report wording in the measures document for ${year}.`];
    });
    return problems.length === 0 ? { success: true, wordings } : { success: false, problems };
}
//# sourceMappingURL=wording.js.map